module.exports = __webpack_public_path__ + "static/media/esafaru-card.019c9c1e.png";